<template>
  <v-row>
    <v-col cols="12" align-self="center">
      <v-tabs v-model="tab" grow show-arrows>
        <v-tabs-slider></v-tabs-slider>
        <v-tab v-for="title in tabTitle" :key="title">
          {{ $t(title) }}
        </v-tab>
      </v-tabs>
      <v-tabs-items v-model="tab" touchless>
        <v-tab-item v-for="(title, index) in tabTitle" :key="title">
          <v-row class="ma-3">
            <v-col xl="4" lg="4" md="4" sm="12" cols="12">
              <v-text-field
                :label="$t('announcements.document_title')"
                @change="updateFileTitle($event, title)"
                :value="document_title[type[index]]"
              ></v-text-field>
            </v-col>
            <v-col xl="6" lg="6" md="6" sm="12" cols="12">
              <v-file-input
                accept="application/pdf,application/msword,
                application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                :label="$t('general.upload_document_file')"
                @change="uploadDocument($event, title)"
              ></v-file-input>
            </v-col>
            <v-col xl="2" lg="2" md="2" sm="12" cols="12" class="d-flex align-center justify-center">
              <v-btn
                color="accent"
                depressed
                :disabled="disable_preview[type[index]]"
                :href="preview_document[type[index]]"
                target="_blank"
              >
                {{ $t('general.preview') }}
              </v-btn>
            </v-col>
          </v-row>
        </v-tab-item>
      </v-tabs-items>
    </v-col>
  </v-row>
</template>

<script>
import { globalFunc, MEDIA_PATH } from '@/global'
import { getData, postData } from '@/api'

export default {
  name: 'UploadFileTab',
  mixins: [globalFunc, MEDIA_PATH],
  props: ['document', 'document_title'],
  data: () => ({
    tab: null,
    type: ['zh', 'en', 'cn'],
    tabTitle: ['general.zh', 'general.en', 'general.cn'],
    preview_document: {
      zh: '',
      en: '',
      cn: '',
    },
    disable_preview: {
      zh: true,
      en: true,
      cn: true,
    },
  }),
  watch: {
    document: function (newVal, oldVal) {
      if (globalFunc.DataValid(newVal.zh)) {
        this.preview_document.zh = MEDIA_PATH + newVal.zh
        this.disable_preview.zh = false
      }
      if (globalFunc.DataValid(newVal.en)) {
        this.preview_document.en = MEDIA_PATH + newVal.en
        this.disable_preview.en = false
      }
      if (globalFunc.DataValid(newVal.cn)) {
        this.preview_document.cn = MEDIA_PATH + newVal.cn
        this.disable_preview.cn = false
      }
    },
  },
  methods: {
    updateFileTitle(event, title) {
      this.$emit('getDocumentName', event, title)
    },
    async uploadDocument(files, title) {
      try {
        if (files == null) {
          if (title == this.tabTitle[0]) {
            this.preview_document.zh = ''
            this.disable_preview.zh = true
            this.$emit('getDocument', null, 'zh')
          } else if (title == this.tabTitle[1]) {
            this.preview_document.en = ''
            this.disable_preview.en = true
            this.$emit('getDocument', null, 'en')
          } else if (title == this.tabTitle[2]) {
            this.preview_document.cn = ''
            this.disable_preview.cn = true
            this.$emit('getDocument', null, 'cn')
          }
          return
        }

        let params = new URLSearchParams()
        let base64Path = await globalFunc.firstFileToBase64(files)
        let type = files.name.substring(files.name.lastIndexOf('.') + 1)
        params.set(
          'upload_file',
          JSON.stringify({
            upload_data: base64Path,
            upload_file_type: type,
          }),
        )

        let upload_file = await postData(params)

        if (title == this.tabTitle[0]) {
          this.preview_document.zh = MEDIA_PATH + upload_file
          this.disable_preview.zh = false
          this.$emit('getDocument', upload_file, 'zh')
        } else if (title == this.tabTitle[1]) {
          this.preview_document.en = MEDIA_PATH + upload_file
          this.disable_preview.en = false
          this.$emit('getDocument', upload_file, 'en')
        } else if (title == this.tabTitle[2]) {
          this.preview_document.cn = MEDIA_PATH + upload_file
          this.disable_preview.cn = false
          this.$emit('getDocument', upload_file, 'cn')
        }
      } catch (error) {
        globalFunc.log(error)
      }
    },
  },
}
</script>
